<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <album-select-group v-model="albumId" label="Album"></album-select-group>
      <picture-select-group v-model="imageId" :album-id="albumId" label="Image"></picture-select-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapImageIdToImage, mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'generic-image',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['image']),
      ...mapTemplateData(['albumId', 'imageId'])
    },
    watch: {
      ...mapImageIdToImage('albumId', 'imageId', 'image')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/generic-image.vue